import {Component, Input, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {PostingDataResponseModel, EditPostingState, UpdateSelectedPostingForm, EditPostingFormNames, EditPostingForms, PostingTypes } from 'remarketing-angular-library';
import {EditPostingUtilsService} from '../../services/edit-posting-utils.service';
import {takeUntil} from 'rxjs/operators';
import {SaComponent} from 'smartauction-frontend-micro-library';
import { PostingFormTrackingService } from '../../services/posting-form-tracking.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { ErrorIconComponent } from 'remarketing-ui-components-lib';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-edit-posting-nav',
    templateUrl: './edit-posting-nav.component.html',
    styleUrls: ['./edit-posting-nav.component.scss'],
    imports: [TranslocoDirective, ErrorIconComponent, CommonModule]
})
export class EditPostingNavComponent extends SaComponent implements OnInit {
  EditPostingForms = EditPostingForms;
  EditPostingFormNames = EditPostingFormNames;
  selectedPostingForm = 0;
  isDisabled = false;

  isDesktop = false;
  activeChildRoute: string;
  readonly activeClass = 'edit-posting-nav__link--active';
  postingData: PostingDataResponseModel;
  @Input()
  disableLinksForHold: boolean;
  validationFailedForms: string[] = [];
  postingType: PostingTypes;

  constructor(
    private readonly store: Store,
    private readonly editPostingUtilsService: EditPostingUtilsService,
    private readonly postingFormTrackingService: PostingFormTrackingService
  ) {
    super();
  }

  ngOnInit() {
    this.store
      .select(EditPostingState.selectedForm)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(selectedForm => (this.selectedPostingForm = selectedForm));
    this.editPostingUtilsService.clearFailedValidationFormsArray();
    this.editPostingUtilsService.validationFailedForms.pipe(takeUntil(this.destroyed$)).subscribe(forms => {
      this.validationFailedForms = forms;
    });
    this.store
      .select(EditPostingState.postingType)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(postingType => (this.postingType = postingType));
  }

  navigateTo(selectedPostingForm: EditPostingForms) {
    this.store.dispatch(new UpdateSelectedPostingForm(selectedPostingForm));
  }

  showErrorIcon(formName: string): boolean {
    if (this.postingType === PostingTypes.NEW) {
      return this.validationFailedForms.includes(formName) || this.newPostingViewedButInvalid(formName);
    } else {
      return this.validationFailedForms.includes(formName);
    }
  }

  showSuccessIcon(formName: string): boolean {
    return !this.validationFailedForms.includes(formName) && this.newPostingViewedAndValid(formName);
  }

  newPostingViewedAndValid(formName: string): boolean {
    return this.postingFormTrackingService.isNewPostingViewedAndValid(this.postingType, formName);
  }

  newPostingViewedButInvalid(formName: string): boolean {
    return this.postingFormTrackingService.isNewPostingViewedButInvalid(this.postingType, formName);
  }

  /* Disable tire link if vehicle is pending inspection.
   */
  get disableTires(): boolean {
    return this.disableLinksForHold;
  }
}
